export default {
      id: "ms-excel-document-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "mysource_files/sprite-map.svg#ms-excel-document",
      toString: function () {
        return this.url;
      }
    }